import { ConfirmDestructiveDialog } from '@/shared/components/ConfirmDestructiveDialog';

/**
 * Confirms deleting one trigger profile (spec 074, US2, FR-005/FR-006).
 * States plainly that run history is retained — the whole point of soft-
 * delete over a hard delete — and that the action cannot be undone.
 * Mirrors `DeleteConnectionDialog`'s shape: the page owns the mutation and
 * passes a refusal back in as `error`.
 */
export function DeleteTriggerProfileDialog({
  profileName,
  open,
  isPending,
  error,
  onConfirm,
  onCancel,
}: {
  profileName: string;
  open: boolean;
  isPending: boolean;
  error?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <ConfirmDestructiveDialog
      open={open}
      title={<>Delete &ldquo;{profileName}&rdquo;?</>}
      confirmLabel="Delete trigger"
      isPending={isPending}
      error={error}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      This stops &ldquo;{profileName}&rdquo; from running or matching any
      further transitions. Its run and signal history is kept and stays visible,
      labeled as deleted. This cannot be undone.
    </ConfirmDestructiveDialog>
  );
}
